import { Configuration } from "../Repository/eventbookyapi";

export const GetApiConfiguration = () => {
    return new Configuration({
        basePath: process.env.REACT_APP_API_URL_BASE,
        credentials: 'include'
    });
}

export const GetApiConfigurationMember = () => {
    return new Configuration({
        basePath: process.env.REACT_APP_API_URL_BASE,
        credentials: 'include'
    });
}